<template>
  <div class="reminder-card">
    <div class="reminder-card__content">
      <svg-loader
        src="/static/images/helpcenter-lamp.svg"
        class="reminder-card__icon"
      />
      <div class="reminder-card__body">
        <p class="reminder-card__titulo">{{ titulo }}</p>
        <p class="reminder-card__descricao">{{ descricao }}</p>
        <button
          v-if="textoBotao"
          class="reminder-card__botao"
          @click="$emit('click-botao')"
        >
          {{ textoBotao }}
        </button>
      </div>
    </div>
    <div class="reminder-card__barra">
      <div class="reminder-card__barra-seg reminder-card__barra-seg--1" />
      <div class="reminder-card__barra-seg reminder-card__barra-seg--2" />
      <div class="reminder-card__barra-seg reminder-card__barra-seg--3" />
      <div class="reminder-card__barra-seg reminder-card__barra-seg--4" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReminderCard',
  props: {
    titulo: { type: String, required: true },
    descricao: { type: String, required: true },
    textoBotao: { type: String, default: '' },
  },
}
</script>

<style scoped lang="scss">
.reminder-card {
  display: flex;
  align-items: stretch;
  background-color: #fff5d6;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 16px;

  &__content {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    flex: 1;
    padding: 16px 20px;
  }

  &__icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin: 0;
    margin-top: 2px;

    ::v-deep path {
      fill: #f78e26;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__titulo {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    line-height: 1.4;
  }

  &__descricao {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 1.5;
  }

  &__botao {
    font-family: 'Exo 2', sans-serif !important;
    align-self: flex-start;
    padding: 0 16px;
    height: 32px;
    border: none;
    border-radius: 4px;
    background-color: #7f1a54;
    color: #ffffff;
    font-size: 11.11px;
    font-weight: 700;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: darken(#7f1a54, 8%);
    }
  }

  &__barra {
    display: flex;
    flex-direction: row;
    width: 52px;
    flex-shrink: 0;
  }

  &__barra-seg {
    flex: 1;

    &--1 {
      background-color: #f78e26;
    }
    &--2 {
      background-color: #f05253;
    }
    &--3 {
      background-color: #ec2072;
    }
    &--4 {
      background-color: #7f1a54;
    }
  }
}
</style>
